import { useCallback } from 'react';
import { hasFormMode } from '../modules/taboola-common-frontend-modules/forms/utils/hasFormMode';
import { useMultiLayerDrawerEnabled } from '../modules/taboola-common-frontend-modules/multi-layer-drawer/hooks/useMultiLayerDrawerEnabled';
import { useDrawerStack } from './queryParams/useDrawerStack';
import { useHistoryNavigate } from './useHistoryNavigate';
import { useModuleName } from './useModuleName';

export const useNavigate = () => {
    const { push, replace } = useDrawerStack();
    const historyNavigate = useHistoryNavigate();
    const isMultiLayerDrawerEnabled = useMultiLayerDrawerEnabled();
    const moduleName = useModuleName();

    const navigate = useCallback(
        (path, options = {}) => {
            const { replaceForm, useDrawer = true } = options;

            if (useDrawer && isMultiLayerDrawerEnabled && hasFormMode(path)) {
                if (replaceForm) {
                    replace({ path });
                    return;
                }
                push({ path, module: `/${moduleName}` });
                return;
            }

            historyNavigate(path, options);
        },
        [isMultiLayerDrawerEnabled, historyNavigate, push, replace, moduleName]
    );

    return navigate;
};
